type ParamValues = Record<string, unknown>;

type GenerateExportFileNameParams = {
  reportName: string,
  paramValues?: ParamValues,
  environmentSuffix?: string,
  includeDateTime?: boolean,
}

export const dateOptions: Intl.DateTimeFormatOptions = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const timeOptions: Intl.DateTimeFormatOptions = {
  hour12: false,
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};

const formatDateTime = (date: Date) => {
  const datePart = new Intl.DateTimeFormat('default', dateOptions)
    .format(date)
    .replaceAll('/', '-');

  const timePart = new Intl.DateTimeFormat('default', timeOptions)
    .format(date)
    .replaceAll(':', '-');

  return `${datePart}_${timePart}`;
};

const getParamValuesLabel = (paramValues: ParamValues | undefined) => {
  if (paramValues) {
    const values = Object.values(paramValues)
      .map(value => String(value).replace(/[.@]/g, '_'))
      .join('_');

    if (values) {
      return `_${values}`;
    }
  }

  return '';
};


export const generateExportFileName = ({
  paramValues,
  reportName,
  environmentSuffix,
  includeDateTime = false,
}: GenerateExportFileNameParams) => {
  const paramValuesLabel = getParamValuesLabel(paramValues);
  const dateTimeLabel = includeDateTime ? `_${formatDateTime(new Date())}` : '';

  const labels = [
    'TLS_',
    reportName,
    paramValuesLabel,
    dateTimeLabel,
    environmentSuffix,
  ].filter(label => label);

  return labels.join('');
};
